/**
 * AsyncDatePicker
 */
import 'react-datepicker/dist/react-datepicker.css';

// Components
import asyncComponent from '../AsyncComponent';

const AsyncDatePicker = asyncComponent(() => import('react-datepicker'));

export default AsyncDatePicker;
